import cookie from 'cookie-utils-js';
import { mapGetters } from 'vuex';
import { getProductList } from '@/api/shop';
import { mixins } from '@/mixins';
import SkuItem from '@/components/SkuItem/SkuItem.vue';
import NoMoreData from '@/components/NoMoreData/NoMoreData.vue';
import AreaLoading from '@/components/AreaLoading/AreaLoading.vue';
import DataPlaceHolder from '@/components/DataPlaceHolder/DataPlaceHolder.vue';

export default {
  components: {
    SkuItem,
    NoMoreData,
    AreaLoading
  },
  
  name: 'Shop',

  mixins: [mixins],

  data() {
    return {
      firstLoading: false,
      productList: [],
    }
  },

  computed: {
    ...mapGetters([
      'pageBackgroundColor',
      'cardBackgroundColor',
      'hignlightBorderColor',
      'cardBtnBackgroundColor',
      'primaryBtnBackgroundColor',
      'virtualCurrencyUnit'
    ]),
  },

  mounted() {
    this.init();
  },

  methods: {
    async init() {
      this.firstLoading = true;
      this.productList = [];
      await this.getProductList();
      this.firstLoading = false;
    },

    async getProductList(opts) {
      const appid = cookie.get('App-Id') || this.debugAppId;
      const token = cookie.get('token') || this.debugToken;
      const res = await getProductList({
        token,
        appid,
      });
      const currentList = this.makeRenderList(res.data.list);

      this.productList = this.productList.concat(currentList);
    },

    onClickSku(opts) {
      this.$router.push({
        path: `/product_detail`,
        query: {
          id: opts.product_id
        }
      });
    },

    makeRenderList(dataList) {
      return dataList.map((item) => {
        return {
          product_id: item.product_id,
          price_type: item.price_type,
          price: item.price,
          name: item.name,
          imgs: item.imgs,
          description: item.description
        };
      });
    },
  }
}



